import { BrandMark, SignIn, useAuth } from "@mattfinkel/common-web";
import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import FeedbackPage from "./feedback/FeedbackPage";
import { auth, googleProvider } from "./firebase";
import Launchpad from "./launchpad/Launchpad";

function Gate({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm text-center">
        <BrandMark brand="me" alt="" className="mx-auto h-20 w-20 rounded-3xl shadow-xl shadow-black/30" />
        <h1 className="mt-5 text-3xl font-semibold text-ink">Home</h1>
        <p className="mt-1 text-sm text-ink-muted">Matt&apos;s apps, in one place.</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  );
}

export default function App() {
  const { state, signOut, retry } = useAuth();

  if (state.status === "allowed") {
    return (
      <Routes>
        <Route element={<Layout email={state.user.email} onSignOut={signOut} />}>
          <Route index element={<Launchpad />} />
          <Route path="review" element={<FeedbackPage />} />
          <Route path="profile" element={<Navigate to="/" replace />} />
          <Route path="prices/*" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    );
  }

  return (
    <Gate>
      {state.status === "idle" && <SignIn auth={auth} provider={googleProvider} />}
      {state.status === "verifying" && <p className="text-sm text-ink-muted">Verifying access…</p>}
      {state.status === "unavailable" && (
        <div className="space-y-4">
          <p className="rounded-xl border border-danger/40 bg-danger/10 px-4 py-3 text-sm text-ink">Could not reach the server: {state.reason}</p>
          <button type="button" onClick={retry} className="rounded-xl bg-ink px-4 py-2 text-sm font-semibold text-surface-sunken">Try again</button>
        </div>
      )}
      {state.status === "denied" && (
        <div className="space-y-4">
          <p className="rounded-xl border border-danger/40 bg-danger/10 px-4 py-3 text-sm text-ink">Access denied: {state.reason}</p>
          <SignIn auth={auth} provider={googleProvider} />
        </div>
      )}
    </Gate>
  );
}
